// Добавление кнопки "Читать еще"
class AddShowMoreButton {
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;

        this.createAndInsertButton();
    }

    /**
     * Создание и добавление в документ кнопки.
     * 
     * @returns {void}
     */
    createAndInsertButton() {
        let span = document.createElement("span");        
        if (this.el.closest(".social-activity")) {
            span.className = "social-activity__more js-show-detail";
        } else {
            span.className = "appeal__more d-xl-none js-show-detail";
        }
        span.innerHTML = "Читать больше...";
        this.el.after(span);
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-short-text")
        .forEach(card => new AddShowMoreButton(card));
});